import React from 'react'
import Layout from '../../components/Layout'
import '../index.css'
import { Link } from 'gatsby'

import analysts_Commander_ENTJ_personality_header from '../../images/personality_types_details/analysts_Commander_ENTJ_personality_header.svg'
import analysts_Commander_ENTJ_career_path from '../../images/personality_types_details/analysts_Commander_ENTJ_career_path.svg'
import circleforward from '../../images/personality_types_details/circleforward.png'
import circleback from '../../images/personality_types_details/circleback.png'

const entj_careers = () => {
    return (
        <Layout>
            <main class="q-td analyst commander">
                {/* --------------------mobile child nav bar------------------------ */}
                <nav className="top-tabs mobile-only" aria-label="Personality description">

                    <Link to='/personality-types/commander-entj-personality' className="tab with-progress">
                        <span className="title">Introduction</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/commander-entj-strengths-and-weaknesses" className="tab with-progress">
                        <span className="title">Strengths and Weaknesses</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/commander-entj-relationships-dating" className="tab with-progress ">
                        <span className="title">Romantic Relationships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab with-progress">
                        <span className="title">Friendships</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/commander-entj-parents" className="tab with-progress ">
                        <span className="title">Parenthood</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/commander-entj-careers" className="tab with-progress active">
                        <span className="title">Career Paths</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/commander-entjs-at-work" className="tab with-progress ">
                        <span className="title">Workplace Habits</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/personality-types/commander-entj-conclusion" className="tab with-progress ">
                        <span className="title">Conclusion</span>
                        <span className="progress"></span>
                    </Link>
                    <Link to="/" className="tab premium">
                        <span className="title">Premium Profile</span>
                    </Link>

                </nav>
                {/* -------------------- picture and title-------------------------- */}
                <header class="type-header analyst commander">

                    <svg class="background" viewBox="0 0 1920 600" preserveAspectRatio="none">
                        <path class="st0" d="M400 598.9l1520-152.8v164.4H0v-288z"></path>
                        <path class="st1" d="M923.4 546.3l996.6-97.4V1.5h-851z"></path>
                    </svg>

                    <img src={analysts_Commander_ENTJ_personality_header} class="scene" alt='loading...'/>
                    <div class="type-info">
                        <h1><span>Commander</span> Personality</h1>
                        <div class="code">ENTJ-A / ENTJ-T</div>
                        <a href="#" class="difference">(What’s the difference?)</a>
                    </div>

                </header>



                {/* -------------------------side bar section------------------------------------- */}
                <div className="with-sidebars">

                    <div className="sidebar left">
                        <nav className="sections" id="sticky-sidebar" style={{ paddingTop: '50px' }}>
                            <div className="title">Explore This Type</div>
                            <ul>
                                <li className=""><Link to='/personality-types/commander-entj-personality'>Introduction</Link></li>
                                <li className=""><Link to="/personality-types/commander-entj-strengths-and-weaknesses">Strengths & Weaknesses</Link></li>
                                <li className=""><Link to="/personality-types/commander-entj-relationships-dating">Romantic Relationships</Link></li>
                                <li className=""><Link to="/personality-types/commander-entj-friends">Friendships</Link></li>
                                <li className=""><Link to="/personality-types/commander-entj-parents">Parenthood</Link></li>
                                <li className="active"><Link to="/personality-types/commander-entj-careers">Career Paths</Link></li>
                                <li className=""><Link to="/personality-types/commander-entjs-at-work">Workplace Habits</Link></li>
                                <li className=""><Link to="/personality-types/commander-entj-conclusion">Conclusion</Link></li>
                                <li className="premium"><Link to="/">Premium Profile</Link></li>
                            </ul>
                        </nav>
                        <daily-insight v-cloak personality-type="INTJ"></daily-insight>
                    </div>
                    {/* ----------------------------description pages of sidebar------------------------------------- */}
                    <article class="main description">

                        <h1>    Career Paths
</h1>


                        <p>It is in the world of careers that Commanders’ boldness and drive are truly at their best. No other personality type is better suited than Commanders to be the respected leader of an organization or team, and no other personality type enjoys it quite so much. Combining their vision, intelligence and determination to push ideas through to completion no matter the obstacles, Commanders are a force to be reckoned with.</p>

                        <div class="scene">
                            <img alt="Commander (ENTJ) careers" src={analysts_Commander_ENTJ_career_path} alt="Commander (ENTJ) careers" />
                        </div>

                        <h2>We All Go Up, or We All Go Down</h2>

                        <p>In the world of business, the sometimes overbearing level of self-confidence that Commanders (especially Assertive ones) too often mishandle in their personal relationships is transformed into an admirable authority, keeping people on track and getting things done. Naturally the best careers for people with the Commander personality type make the fullest use of these qualities, and many would describe executive positions and entrepreneurialism to be ideal lines of work – any position high enough that they can clearly see the horizon.</p>

                        <div class="description-pullout">For Commanders, failure is not an option – they conceive a vision of the future, formulate a strategy to achieve that vision, and execute each step with ruthless precision.</div>

                        <p>Structure and order are key, and if someone gets sloppy, or holds things back with incompetence, laziness or inefficiency, Commanders will not hesitate to come down, hard. Commander personalities pursue their goals with singular vision, and have strict standards for themselves and others that are designed above all else to be effective. This makes Commanders excellent corporate strategists, and their objectivity and clarity of thought make them respected lawyers and judges.</p>

                        <p>None of this could work if no one could understand what Commanders were thinking, and they have the good fortune of being clear and concise communicators, especially in person, making business administration a comfortable fit – so long as their tasks don’t stray too far into routine maintenance and upkeep. Commanders also have a thirst for knowledge, and they aren’t afraid to use a principle once they’ve grasped its underlying mechanisms. Combining this with their leadership makes Commanders trying, but effective, university professors.</p>

                        <h2>We Are Still in the Making</h2>

                        <p>The only problem is, it takes time for Commanders’ skills to be recognized, and stagnating as low-level employees will have them bouncing off the walls and deeply unhappy. People with the Commander personality type crave leadership and responsibility, growth and opportunity, and genuinely enjoy managing others to get a job done. Commanders are visionaries and leaders, not grunts or day-to-day administrators. Getting that to be recognized is not always easy, but Commanders are probably up to the task.</p>

                        <div class="number">06</div>


                    </article>
                </div>

                <div className="navigation-buttons comp" data-chunk="type-chunk">
                    <div className="part left">
                        <Link to='/personality-types/commander-entj-parents' className='next-feature'>
                            Parenthood
                       <br /><br />
                            <img src={circleback} width={75} height={75} />
                        </Link>
                    </div>
                    <div className="part right">
                        <Link to='/personality-types/commander-entjs-at-work' className='next-feature'>
                            Workplace Habits
                       <br /><br />
                            <img src={circleforward} width={75} height={75} />
                        </Link>
                    </div>
                </div>

            </main>
        </Layout>
    )
}

export default entj_careers
